export default __webpack_public_path__ + "static/media/05.d4df2563.jpg";